import { combineReducers } from '@reduxjs/toolkit';
import Auth from "./Auth"; // Import your Auth reducer

// Combine reducers
const rootReducer = combineReducers({
    auth: Auth, // Add other reducers here as needed
});

export default rootReducer;